





















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { ImageSpec } from '@/types'
import { goToImageSpec } from '@/utils/urlQuery.ts'

import ImageUploaderButton from '@/components/ImageUploaderButton.vue'

import BackgroundImage from '@/store/current/backgroundImage.ts'
import GalleryImages from '@/store/galleryImages.ts'

const backgroundImage = getModule(BackgroundImage)
const galleryImages = getModule(GalleryImages)

@Component({
  components: {
    ImageUploaderButton
  }
})
export default class Gallery extends Vue {
  get imageSpecs (): ImageSpec[] {
    return galleryImages.asArray
  }
  get selected (): number {
    return this.imageSpecs.findIndex(spec => spec.src === backgroundImage.src)
  }
  set selected (idx: number) {
    // Update the URL with the selected image.
    goToImageSpec(this.imageSpecs[idx])
  }
  addFiles (files: File[]) {
    galleryImages.appendFromFiles(files)
    files = []
  }
}
